<template>
  <div class="l_registration">
    <template v-if="this.registerInfo.length > 0">
      <p v-if="!this.registered" class="alert">
        プロフィールを全て入力すると<br />
        スタンプが1つもらえます。
      </p>
      <div class="l_container">
        <div
          class="l_form"
          v-for="(item, index) in this.registerInfo"
          :key="`form_${index}`"
        >
          <div class="l_input">
            <p class="c_title">
              {{ item.name }} (任意)
              {{ formNotes(item.register_manage_id, canUpdateBirthMonth, canUpdateBirthDay) }}
            </p>
            <!-- Selectbox -->
            <template v-if="__checkInputType(item.input_type, '0')">
              <div class="l_select" v-if="userData">
                <select-box
                  :list="item.items"
                  :registerId="item.register_manage_id"
                  :value="user[item.register_manage_id]"
                  @change="__onChangeSelectbox"
                  @focus="__onFocusSelectbox"
                  :disabled="canNotUpdateRegisteredData(item.register_manage_id, canUpdateBirthMonth, canUpdateBirthDay)"
                />
              </div>
            </template>

            <!-- テキスト入力 TODO: ダミー -->
            <template v-if="__checkInputType(item.input_type, '1')">
              <input class="c_input" type="text" />
            </template>

            <!-- 都道府県  -->
            <template v-if="__checkInputType(item.input_type, '2')">
              <div class="l_select" v-if="userData">
                <select-box
                  :list="prefectures"
                  :registerId="item.register_manage_id"
                  :value="user[item.register_manage_id]"
                  @change="__onChangePrefecture"
                  @focus="__onFocusPrefecture"
                />
              </div>
            </template>

            <!-- 市区町村 -->
            <template v-if="__checkInputType(item.input_type, '3')">
              <div class="l_select" v-if="userData">
                <select-box
                  :list="currentCities"
                  :registerId="item.register_manage_id"
                  :value="user[item.register_manage_id]"
                  @change="__onChangeCity"
                  @focus="__onFocusCity"
                />
              </div>
            </template>
          </div>
        </div>
        <!-- Alert パネル -->
        <template v-if="isAlert">
          <alert
            :title="alertTitle"
            :message="alertMessage"
            :label="'OK'"
            @submit="() => tapAlertSubmit()"
            @close="() => tapAlertClose()"
          />
        </template>
      </div>
      <div class="button-action">
        <a @click="this.tapSubmit"><p>変更する</p></a>
      </div>
    </template>
    <!-- エラーパネル -->
    <template v-if="isError">
      <error-popup
        :title="errorTitle"
        :message="errorMsg"
        :label="'もう一度試す'"
        @submit="() => tapRetryFetch()"
        @close="() => tapErrorClose()"
      />
    </template>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { pluck, map } from 'rxjs/operators'
import moment from 'moment' // source https://www.npmjs.com/package/moment
import { ja } from 'vuejs-datepicker/dist/locale' // source https://github.com/charliekassel/vuejs-datepicker
import SelectBox from '@/components/CSelectBox.vue'
import DateFormatter from '../utils/DateFormatter.js'
import ErrorPopup from '@/components/Modal/ErrorPopup.vue'
import Alert from '@/components/Modal/Alert.vue'
import app from '../constant/app_config.js'
import { ErrorCode, ErrorMessage } from '@/api/APIClient'
import { FactoryTrack } from '../constant/firebase'
import '@/styles/color.css'
export default {
  name: 'ProfileSetting',
  components: {
    SelectBox,
    ErrorPopup,
    Alert
  },
  subscriptions: function() {
    return {
      user: this.$watchAsObservable('userData').pipe(
        pluck('newValue'),
        map(data => {
          const user = {}
          data.forEach(x => {
            if (x.input_type === '0') {
              user[x.id] = x['register_form_item_id']
            } else {
              user[x.id] = x['text']
            }
          })

          // set current cities
          this.registerInfo.forEach(x => {
            if (this.__checkInputType(x.input_type, '2')) {
              const id = ('0' + x.register_manage_id).slice(-2)

              const items = this.prefectures.filter(
                pre => pre.item_id === user[id]
              )
              if (items.length > 0) {
                this.currentCities = this.cities[items[0].item]
              }
            }
          })

          // set selected month on load
          this.actionSetSelectedMonth(user[app.api.month])
          return user
        })
      )
    }
  },
  data() {
    return {
      title: 'プロフィール設定・変更',
      currentCities: [],
      birthday: '01/01',
      // user: {}, // 選択されたデータはここに入ります。
      ja: ja,
      isError: false,
      errorMsg: '',
      errorTitle: '',
      errorType: '',
      isAlert: false,
      alertTitle: '',
      alertMessage: '',
      isComplete: '0',
      canUpdateBirthMonth: true,
      canUpdateBirthDay: true
    }
  },
  computed: {
    ...mapGetters({
      registerInfo: 'User/registerInfo',
      prefectures: 'Location/prefectures',
      cities: 'Location/cities',
      userData: 'User/user',
      userId: 'User/userId',
      registered: 'User/registered'
    })
  },
  watch: {
    userId: function(value) {
      // TODO: 投稿データを全て調べる
      console.log('watch userID ', value)
      // check user data.  complete or not complete
      var count = 0
      Object.keys(this.user).forEach(item => {
        if (this.user[item] !== '' && this.user[item]) {
          count++
        }
        if (count === this.registerInfo.length) {
          this.isComplete = '1'
        }
      })
      console.log(this.isComplete)
      this.isAlert = true
      this.alertTitle = 'プロフィールを変更しました。'
      // this.alertMessage = 'プロフィールを変更しました。'
    }
  },
  async created() {
    document.title = this.title
    const isLoacation = await this.fetchLocation()
    if (!isLoacation) {
      console.log('Locationデータの取得に失敗')
      return
    }
    const accTime = new DateFormatter().format(new Date())
    try {
      window.receivedToken = payload => {
        const json = JSON.parse(payload)
        console.log('%%%%%%%%%%%%%%')
        console.log(json)
        this.fetchRegisterInfo(json.app_token, accTime, json.device_id)
        window.receivedToken = null
      }
      console.log(window.receivedToken)
      this.actionRequestToken({ apiType: '1', acc_time: accTime })
    } catch (e) {
      this.errorTitle = 'エラー' + ErrorCode.CODE_ERROR_TOKEN
      this.errorMsg = ErrorMessage.MSG_ERROR_TOKEN
      this.isError = true
      console.log(e)
    }

    // 初期の市区町村設定
    this.currentCities = this.cities[this.prefectures[0].item]
  },
  methods: {
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('User', [
      'actionFetchRegisterInfo',
      'actionFetchUserData',
      'actionUpdateUserData'
    ]),
    ...mapActions('Location', ['action_FetchLocation']),
    ...mapActions('Native', ['actionRequestToken', 'actionSendRegisterParams']),
    ...mapActions('FormRegisterUser', ['actionSetSelectedMonth']),
    ...mapActions('Analytics', ['trackEvent']),
    // Locationデータを読み込む
    async fetchLocation() {
      try {
        await this.action_FetchLocation()
        return true
      } catch (e) {
        console.log(e)
        if (this.errorType.length === 0) {
          this.errorType = 'location'
          this.errorMsg = e.message
          this.isError = true
        }
        return false
      }
    },
    // 入力情報を取得
    async fetchRegisterInfo(token, accTime, deviceId) {
      this.actionToggleLoading(true)
      try {
        await this.actionFetchRegisterInfo({
          token: token,
          accTime: accTime,
          deviceId: deviceId
        })
        this.requestUserData()
      } catch (e) {
        console.log(e)
        // TODO: エラーアラート追加
        if (this.errorType.length === 0) {
          this.errorType = 'register'
          this.errorMsg = e.message
          this.isError = true
        }
      }
    },
    // ユーザー情報を取得
    async fetchUserData(token, accTime, userId) {
      try {
        await this.actionFetchUserData({
          token: token,
          accTime: accTime,
          userId: userId
        })
        this.canUpdateBirthMonth = this.user['67'] === ''
        this.canUpdateBirthDay = this.user['68'] === ''
      } catch (e) {
        console.log(e)
        if (this.errorType.length === 0) {
          this.errorType = 'user'
          this.errorMsg = e.message
          this.isError = true
        }
      }
      this.actionToggleLoading(false)
    },
    // ユーザー情報を取得する
    requestUserData() {
      const accTime = new DateFormatter().format(new Date())
      try {
        window.receivedToken = payload => {
          const json = JSON.parse(payload)
          this.fetchUserData(json.app_token, accTime, json.user_id)
          window.receivedToken = null
        }
        // クーポン一覧と同じなので一旦apiTypeを3に設定する
        this.actionRequestToken({ apiType: '3', acc_time: accTime })
      } catch (e) {
        console.log(e)
      }
    },

    customFormatter(date) {
      return moment(date).format('MM/DD')
    },
    // tap alert submit
    tapAlertSubmit() {
      console.log('** tap alert submit **')
      this.actionSendRegisterParams({
        isComplete: this.isComplete,
        userId: this.userId,
        isUpdate: '1'
      })
    },
    // 最新データを取得
    tapRetryFetch() {
      this.trackEvent(FactoryTrack.createErrorRetry())
      switch (this.errorType) {
        case 'location':
          this.fetchLocation()
          break
        case 'register':
          this.$router.go()
          break
        case 'user':
          this.fetchUserData()
          break
        case 'submit':
          this.tapSubmit()
          break
        default:
          this.$router.go()
      }
      this.errorType = ''
    },
    // エラーポップアップ閉じるボタン
    tapErrorClose() {
      this.trackEvent(FactoryTrack.createErrorClose())
      this.isError = false
    },
    // alert close method
    tapAlertClose() {
      this.isAlert = false
    },
    // 変更ボタン処理
    async tapSubmit() {
      try {
        this.trackEvent(FactoryTrack.createProfileUpdate()) // Tacking
      } catch (e) {
        console.log('-------------------')
        console.log(e.toString())
        console.log('==============-')
      }

      this.actionToggleLoading(true)
      const accTime = new DateFormatter().format(new Date())
      const params = { apiType: '2', acc_time: accTime }
      Object.keys(this.user).forEach(key => {
        if (
          this.user[key] !== '' &&
          this.user[key] !== null &&
          this.user[key] !== undefined
        ) {
          params[`register_manage_${key}`] = String(this.user[key])
        }
      })
      try {
        window.receivedToken = payload => {
          const json = JSON.parse(payload)
          this.__postUserData(json)
          window.receivedToken = null
        }
        this.actionRequestToken(params)
      } catch (e) {
        params['app_token'] = ''
      }

      setTimeout(() => {
        this.actionToggleLoading(false)
      }, 300)
    },

    /**
     * ユーザーデータを保存
     */
    async __postUserData(params) {
      try {
        console.log('user dataを送信します。')
        console.log(this.user)
        await this.actionUpdateUserData({ params: params, user: this.user })
      } catch (e) {
        if (e.code) {
          console.log(e)
          console.log('ユーザー登録に失敗しました')
          this.errorTitle = 'エラー' + e.code
          this.errorMsg = e.message
        } else {
          this.errorTitle = 'エラー' + ErrorCode.CODE_ERROR_NETWORK
          this.errorMsg = ErrorMessage.MSG_ERROR_NETWORK
        }
        this.actionToggleLoading(false)
        this.isError = true
        this.errorType = 'submit'
      }
    },
    formNotes(registerManageId, canUpdateBirthMonth, canUpdateBirthDay) {
      let notes = ''
      if (registerManageId === '67' || registerManageId === '68') {
        notes = '※一度登録すると変更できません。'
        const monthOrDay = { '67': '月', '68': '日' }
        if ((registerManageId === '67' && canUpdateBirthMonth) || (registerManageId === '68' && canUpdateBirthDay)) {
          notes = `※生まれた${monthOrDay[registerManageId]}は初回入力後、変更できません。`
        }
      }
      return notes
    },
    canNotUpdateRegisteredData(registerManageId, canUpdateBirthMonth, canUpdateBirthDay) {
      return (registerManageId === '67' && !canUpdateBirthMonth) || (registerManageId === '68' && !canUpdateBirthDay)
    },
    /**
     * インプットタイプ調べる
     * @param {String} managed_id
     * @param {int} target
     */
    __checkInputType(inputType, targetInputType) {
      return inputType === targetInputType
    },
    /**
     * 生年月で利用する、Dateフォーマット
     */
    __customFormatter(date) {
      return moment(date).format('MM/DD')
    },
    /**
     * セレクトボックスのコールバック
     */
    __onChangeSelectbox(data) {
      this.__setUserData(data.registerId, data.item_id)
      if (data.registerId === app.api.month) {
        this.actionSetSelectedMonth(data.item)
      }
    },
    /**
     * select box on focus
     */
    __onFocusSelectbox(data) {
      this.__setUserData(data.registerId, data.item_id)
      if (data.registerId === app.api.month) {
        this.actionSetSelectedMonth(data.item)
      }
    },
    /**
     * 都道府県選択
     */
    __onChangePrefecture(data) {
      console.warn(this.user)
      this.__setUserData(data.registerId, data.item_id)
      this.currentCities = this.cities[data.item]
      if (!this.currentCities) {
        this.__setUserData('64', '')
      }
    },
    /**
     * prefrecture on focus
     */
    __onFocusPrefecture(data) {
      this.__setUserData(data.registerId, data.item_id)
    },
    /**
     * 市町村選択
     */
    __onChangeCity(data) {
      console.warn(data)
      this.__setUserData(data.registerId, data.item_id)
    },
    /**
     * on focus city
     */
    __onFocusCity(data) {
      this.__setUserData(data.registerId, data.item_id)
    },
    /**
     * 生年月取得
     */
    __onSelectedBirth(manageId, data) {
      this.__setUserData(manageId, moment(data).format('MM/DD'))
    },
    /**
     * ユーザーデータを登録する
     * @param {String} registerId
     * @param {String} value
     */
    __setUserData(registerId, value) {
      this.user[registerId] = value
    }
  }
}
</script>
<style scoped>
.l_registration {
  background-color: #ffffff;
  width: 100%;
  min-height: 100%;
  padding-bottom: 5px;
  font-weight: normal;
  letter-spacing: normal;
}

.l_container {
  padding: 20px 12px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  position: relative;
}

/* 入力項目 */
.l_form {
  display: flex;
  flex-direction: row;
  justify-content: left;
  background-color: #ffffff;
}

.l_form + .l_form {
  box-shadow: inset 0 1px 0 0 #dddddd;
}

.l_input {
  width: 100%;
  align-content: left;
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 12px 15px;
}

/* セレクトボックス */
.l_select {
  margin-top: 5px;
}

/* 登録ボタン */
.l_button__submit {
  width: 250px;
  margin: 0 auto;
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translate(-50%, 0);
}

/* 入力項目タイトル */
.c_title {
  font-family: 'HiraKakuPro-W3';
  font-size: 10px;
  line-height: 1;
  color: #777777;
}

.l_registration .button-action {
  border-radius: 6px;
  width: 249px;
  height: 43px;
  background-color: var(--accent-color);
  padding: 14px 14px;
  margin: auto;
}

.l_registration .button-action p {
  font-family: 'HiraKakuPro-W6';
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  color: #ffffff;
  padding: 1px;
}

.alert {
  background-color: #f6c143;
  padding: 4px 0;
  display: block;
  font-size: 12px;
}
</style>
